import React from "react";
import { useApp } from "@/context/AppContext";
import Nav from "@/components/Nav";
import MarketPanel from "@/components/MarketPanel";
import CompetitorTiers from "@/components/CompetitorTiers";
import CompetitorReliability from "@/components/CompetitorReliability";
import CompetitorPriceHistory from "@/components/CompetitorPriceHistory";
import CompetitorOccupancyHeatmap from "@/components/CompetitorOccupancyHeatmap";
import CompetitorFuturePrices from "@/components/CompetitorFuturePrices";
import { Users } from "lucide-react";

export default function Competitors() {
  const { lang, properties, activeId } = useApp();
  const L = (it, en) => (lang === "en" ? en : it);
  const active = properties.find((p) => p.id === activeId) || properties[0];
  const [marketVersion, setMarketVersion] = React.useState(0);

  return (
    <div className="App min-h-screen"><Nav />
      <div className="max-w-7xl mx-auto px-6 py-8" data-testid="competitors-page">
        <div className="flex items-center gap-3 mb-6">
          <Users className="w-7 h-7 text-primary" />
          <div>
            <h1 className="text-3xl font-bold tracking-tight">{L("Competitor", "Competitors")}</h1>
            <p className="text-sm text-muted-foreground">{active ? `${active.name} · ${active.city}` : L("Seleziona una struttura", "Select a property")}</p>
          </div>
        </div>

        {!active ? (
          <div className="py-24 text-center text-muted-foreground">{L("Nessuna struttura selezionata.", "No property selected.")}</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="md:col-span-4">
              <CompetitorOccupancyHeatmap propId={active.id} lang={lang} refreshKey={marketVersion} />
            </div>
            <div className="md:col-span-4">
              <CompetitorFuturePrices propId={active.id} lang={lang} refreshKey={marketVersion} />
            </div>
            <MarketPanel propId={active.id} variant="competitors" onMarketChange={() => setMarketVersion((v) => v + 1)} />
            <CompetitorTiers propId={active.id} lang={lang} refreshKey={marketVersion} />
            <CompetitorReliability propId={active.id} lang={lang} refreshKey={marketVersion} />
            <CompetitorPriceHistory propId={active.id} lang={lang} />
          </div>
        )}
      </div>
    </div>
  );
}
